import { render, staticRenderFns } from "./CardTag.vue?vue&type=template&id=7e65f034&"
import script from "./CardTag.js?vue&type=script&lang=js&"
export * from "./CardTag.js?vue&type=script&lang=js&"
import style0 from "./CardTag.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports